import Search from './search';

export default class TopNavigationSearch {
    constructor(elm, args) {
        this.searchToggleBtn = elm.querySelector('[data-search-toggle]');
        this.body = document.querySelector('body');
        this.headerContainer = document.querySelector('.header__container');
        this.isSearchOpen = false;
        const openSearch = this.openSearch.bind(this);
        this.searchToggleBtn.addEventListener('click', openSearch);
        this.search = new Search(this.headerContainer);

        // hacky mobile menu to hacky script...
        this.isMobile = args?.isMobile;
        let searchToggleBtnMobile = null;
        if (this.isMobile) {
            searchToggleBtnMobile = document.querySelector(
                '[data-search-toggle-mobile]',
            );
            searchToggleBtnMobile.addEventListener('click', openSearch);
        }
    }

    openSearch() {
        if (this.isMobile) {
            document.body.classList.remove('mobile-menu-open');
        }
        if (this.headerContainer.classList.contains('open-search')) {
            this.headerContainer.classList.remove('open-search');
            this.headerContainer.classList.add('close-search');
            this.body.classList.remove('blured');
        } else {
            this.headerContainer.classList.add('open-search');
            this.headerContainer.classList.remove('close-search');
            this.body.classList.add('blured');
        }
        this.search.clearResults();
    }
}
